/**
 * @author Ashish Dwivedi <ashish.dwivedi@314ecorp.com>
 * @description hook for active subscription plans
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * use active subscription plans
 */
const useBillingInfo = (): UseQueryResult<Subscriptions.IBillingInfoModel, IAxiosError> => {
	return useQuery({
		queryKey: [QUERY_KEYS.billingInformation],
		queryFn: async () => {
			const { data } = await api.Subscriptions.getBillingInfo();
			return data;
		},
	});
};

export default useBillingInfo;
